<template>
    <div class="profile-reputation-widgets__widget-logo">
        <MaltImg
            :src="`/hop_${reputation.providerName}_logo`"
            width="32"
            loading="lazy"
            height="32"
            :alt="getImageText(reputation)"
            :title="getImageText(reputation)"
        />
    </div>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {useTranslation} from '#imports';
    import type {ExternalReputationResource} from '~/types/api-raw-types';
    import type {TranslationKey} from '#build/i18n';

    const {t} = useTranslation();
    type Props = {
        reputation: ExternalReputationResource;
    };
    defineProps<Props>();

    function getImageText(reputation: ExternalReputationResource): string {
        return `${t(`profile.reputation.provider.${reputation.providerName}` as TranslationKey)} : ${reputation.externalUsername}`;
    }
</script>
